import React, { useEffect, useMemo, useState } from "react";
import Header from "../../components/Header";
import "moment/locale/zh-cn";
import useCurrentDate from "../../utils/useCurrentDate";
import WeekCalendar from "./components/WeekCalendar";
import _ from "underscore";
import {
    getCourseData,
    getSysMessage,
    readMessage,
    SysMessage,
    toNumber
} from "../../service/service";
import style from "./main.module.scss";
import useRequest from "../../utils/useRequest";
import BatchPicker from "./components/BatchPicker";
import WeekPicker from "./components/WeekPicker";
import useStorage from "../../utils/useStorage";
import Config from "../../config";
import { Icon, Spin } from "antd";
import moment from "moment";
import { useAtomValue } from "jotai";
import { batchNoAtom } from "service/stores/CommonStore";
import NoticeModal from "./components/NoticeModal";
import useModalHandler from "utils/useModalHandler";
import { getSessionList, ReceiverType } from "service/chat";
import { useHistory } from "react-router-dom";
import Storage from "utils/Storage";

export default function PageMain() {
    const modal = useModalHandler();
    const history = useHistory();

    const [notice, setNotice] = useState<SysMessage>();

    const batchNo = useAtomValue(batchNoAtom);
    const [batch] = useStorage("batch", batchNo || Config.DefaultBatch);
    const [CourseData, { loading }] = useRequest(() => getCourseData({}), {}, [
        batch
    ]);
    const [sysMessage] = useRequest(getSysMessage);

    const {
        theWeek,
        startDate: startDateOfBatch,
        endDate: endDateOfBatch,
        time
    } = useCurrentDate();
    const [week, setWeek] = useState(toNumber(theWeek));

    // 切换学期时自动跳转到该学期的当前周, 如果不在学期内切换到第一周
    useEffect(() => {
        if (!time.isBetween(startDateOfBatch, endDateOfBatch))
            return setWeek(1);
        setWeek(toNumber(theWeek));
    }, [theWeek, batch]);

    // 计算所选择周的起止时间
    const [startDate, endDate] = useMemo(() => {
        const startDate = moment(startDateOfBatch)
            .startOf("week")
            .add(week - 1, "weeks")
            .format("YYYYMMDD");
        const endDate = moment(startDate).add(6, "d").format("YYYYMMDD");
        return [startDate, endDate];
    }, [week, startDateOfBatch]);

    // 筛选当前周的排课
    const data = useMemo(() => {
        if (!CourseData) return [];

        const weekData = CourseData.filter(
            item => item.date <= endDate && item.date >= startDate
        );
        const groupData = _.groupBy(weekData, "date");
        const newData = [];

        for (let i = 0; i < 7; i++) {
            const date = moment(startDate).add(i, "d").format("YYYYMMDD");
            newData.push({ day: i.toString(), courses: groupData[date] || [] });
        }

        return newData;
    }, [CourseData, startDate, endDate]);

    const handleShowNotice = (id: string) => {
        modal.open();
        const data = sysMessage?.find(item => item.id === id);

        if (!data) return;
        setNotice(data);
        readMessage(id);
    };

    //会话列表
    const [contacts] = useRequest(() => getSessionList());
    const teacherNo = Storage.get("teacherNo") || "";

    const key = teacherNo + "-" + ReceiverType.Teacher;
    const unreadListByInterface = contacts?.some(item =>
        item.notReadNoTypeList?.includes(key)
    );

    return (
        <div>
            <Header />
            <div className={style.notice}>
                {sysMessage?.length !== 0 &&
                    sysMessage?.map(item => (
                        <div
                            className={style.noticeItem}
                            onClick={() => handleShowNotice(item.id)}
                            key={item.id}>
                            {item.title}
                        </div>
                    ))}

                {unreadListByInterface && (
                    <div
                        className={style.chat}
                        onClick={() => history.push("/chat")}>
                        <Icon type="mail" />
                        您有未读消息，点击可前往聊天查看
                    </div>
                )}
            </div>

            <div className={style.root}>
                <div className={style.header}>
                    <BatchPicker />
                    <WeekPicker
                        week={week}
                        currentWeek={toNumber(theWeek)}
                        onChange={setWeek}
                    />
                </div>

                <Spin spinning={loading}>
                    <WeekCalendar
                        data={data}
                        startDate={startDate}
                        endDate={endDate}
                    />
                </Spin>
            </div>

            {!!notice && (
                <NoticeModal
                    visible={modal.visible}
                    onCancel={modal.close}
                    data={notice}
                />
            )}
        </div>
    );
}
